import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { BaseTextField } from './BaseTextField/BaseTextField';
import { MobileTextField } from './MobileTextField';
export const TextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { mobile } = props, restProps = _object_without_properties(props, [
        "mobile"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    if ((mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice && !isInBottomSheet) {
        return /*#__PURE__*/ _jsx(MobileTextField, _object_spread_props(_object_spread({}, restProps), {
            mobile: mobile,
            ref: ref
        }));
    }
    return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
        ref: ref
    }));
});
